import styled from 'styled-components';

export const AppGeral = styled.div`
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
`;

export const AppLogin = styled.div`
  /* display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh; */
`;
